import type { VariablesOf } from "@graphql-typed-document-node/core";
import { safe } from "pb.safe";

import { $, mutation } from "../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../shared/shared/api-client";

export function assignDeviceToEntity({
	apiClient,
	...variables
}: {
	apiClient: ApiClient;
} & VariablesOf<typeof assignDeviceToEntity.gql.assignDeviceToEntity>) {
	return safe(() =>
		apiClient.request(assignDeviceToEntity.gql.assignDeviceToEntity, variables),
	);
}

assignDeviceToEntity.gql = {
	assignDeviceToEntity: mutation("assignDeviceToEntity", (q) => [
		q.assignDeviceToEntity({
			deviceUuid: $("deviceUuid"),
			entityUuid: $("entityUuid"),
			name: $("name"),
		}),
	]),
};
